export const checkIfCurrentReactionType = (suggestion, reactionId) => {
  return suggestion.reactions.some(
    reaction => reaction.reactionId === reactionId
  )
}
